import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@mui/material';
import { FC, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';

import AttachmentList from '../../../../shared/components/AttachmentList';
import { Attachment, SuccessCriteria } from '../../../../types/work';
import SuccessCriteriaDisplay from '../SuccessCriteriaDisplay';
import { Container, Content, Title } from './styled';

export type Props = {
    title: string;
    content: string;
    height: string;
    attachments: Attachment[];
    successCriteria?: SuccessCriteria[];
};

const useStyles = makeStyles<Theme>(theme => {
    return {
        markdown: {
            '& p > a': {
                color: theme.palette.secondary.main
            },
            '& p > a:visited': {
                color: theme.palette.secondary.dark
            }
        }
    };
});

const Description: FC<Props> = ({ title, content, height, attachments, successCriteria }) => {

    const classes = useStyles();

    const contentnMarkdown = useMemo(
        () => content.replace(/\n/gi, '  \n'),
        [ content ]
    );

    return (
        <Container height={height}>
            <div style={{ flexGrow: 100 }}>
                <Title>{title}</Title>
                <Box height={16} />
                <Content>
                    <ReactMarkdown
                        className={classes.markdown}
                        source={contentnMarkdown}
                        linkTarget="_blank"
                        transformLinkUri={(uri) => {
                            const urlStr = ReactMarkdown.uriTransformer(uri);

                            if (urlStr.indexOf(':') === -1) {
                                return `https://${urlStr}`;
                            } else {
                                return urlStr;
                            }
                        }}
                    />
                </Content>
                <AttachmentList attachments={attachments} />

                {successCriteria && successCriteria.length > 0 && (
                    <>
                        <Box height={16} />
                        <SuccessCriteriaDisplay criteriaList={successCriteria} />
                    </>
                )}

            </div>
        </Container>
    );
};

export default Description;
